import { render } from "./RecommendationNotification.vue?vue&type=template&id=6d3a11d0"
import script from "./RecommendationNotification.vue?vue&type=script&lang=js"
export * from "./RecommendationNotification.vue?vue&type=script&lang=js"

import "./RecommendationNotification.vue?vue&type=style&index=0&id=6d3a11d0&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__